var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlogsResponciveBgIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 556,
    viewBox: "0 0 375 556",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_745_4732)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 269.008,
    height: 1146.21,
    rx: 134.504,
    transform: "matrix(0.642788 -0.766044 0.766083 0.642742 -226 -180.93)",
    fill: "url(#paint0_linear_745_4732)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.4171,
    y: -1.34928,
    width: 164.019,
    height: 495.201,
    rx: 82.0097,
    transform: "matrix(0.642788 -0.766044 0.766083 0.642742 -173.287 192.359)",
    stroke: "url(#paint1_linear_745_4732)",
    strokeOpacity: 0.31,
    strokeWidth: 21.8858
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_745_4732",
    x: -204.272,
    y: -365.278,
    width: 1007.55,
    height: 899.341,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.63,
    result: "effect1_foregroundBlur_745_4732"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_745_4732",
    x1: 165.562,
    y1: -246.794,
    x2: 137.773,
    y2: 1146.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.145708,
    stopColor: "#D0FBEF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373644,
    stopColor: "#C3F8E9",
    stopOpacity: 0.536558
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9AEDD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_745_4732",
    x1: 92.9525,
    y1: 0,
    x2: 92.9525,
    y2: 517.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.495114,
    stopColor: "#D0FBEF",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#778DFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogsResponciveBgIc);
export default __webpack_public_path__ + "static/media/blogsResponciveBg_ic.5ad5dd38.svg";
export { ForwardRef as ReactComponent };